<template>
  <BarChartTemplate
    :chartMainData="getCurrentChartMainData"
    :chartOptionsFuncParams="chartOptionsFuncParams"
    :showYearSelect="false"
    competence
    chartSeriesYKey="totalUsers"
    chartTitle="Компетенции пользователей"
  />
</template>
<script>
import BarChartTemplate from "./templates/BarChartTemplate";
import { graphQueryConstructor } from "@/tools/graphQueryConstructor";
import { gQueryOptionsTemplate } from './chartHelper';
import gql from 'graphql-tag';
import { mapGetters } from 'vuex';

export default {
  name: "CompetenceChart",
  components: {
    BarChartTemplate,
  },
  props: {
    apolloSearchString: {
      type: String,
      default: "",
    },
    userSearchFilters: {
      type: Object,
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
  },
  apollo: {
    competenceDistribution: {
      query() {
        return gql(graphQueryConstructor(
          ...gQueryOptionsTemplate(
              this.hasUserContactsAccess,
              this.apolloSearchString,
              this.userSearchFilters,
              this.selectedTags,
              "competenceDistribution",
              this.year,
            )
        ));
      },
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      competenceDistribution: null,
      chartOptionsFuncParams: {
        title: {
          word: "Пользовател",
          e1: "ь",
          e2: "я",
          e3: "ей",
        },
      },
    };
  },
  methods: {
    yearUpdate(value) {
      this.year = value;
    },
  },
  computed: {
    ...mapGetters('auth', ['hasUserContactsAccess']),
    ...mapGetters(['getAllCompetenceList']),
    getCurrentChartMainData() {
      if(this.competenceDistribution) {
        const distributionSet = new Set(this.competenceDistribution.competencies.map(item => item.competenceId));
        const competenceNames = this.getAllCompetenceList.filter(item => distributionSet.has(item.id)).map(item => item);
        
        const resultcompetenceDistribution = this.competenceDistribution.competencies.map((item, index) => {
          const currentCompetence = competenceNames.find((competenceName) => item.competenceId === competenceName.id);
          return {
            name: currentCompetence.name || "Компетенция не найдена в каталоге компетенций",
            levels: item.levels,
          };
        });
        return {
          competence: resultcompetenceDistribution,
        };
      } else {
        return null;
      }
    },
  },
}; 
</script>
<style>
</style>